const perfectCorp = {
  language: process.env.REACT_APP_LOCALE || 'en',
  chinaAPIUrl: 'https://plugins-media.youcamapi.cn/c20279/sdk.js?apiKey=',
  chinaAPIKey: 'G1k99YQQ5HX4cENMf1bSg==',
  middleEastAPIUrl: 'https://plugins-media.makeupar.com/c42378/sdk.js?apiKey=',
  middleEastAPIKey: 'WsGN6sbcLKS6sNpW64bLw',
  russiaAPIUrl: 'https://plugins-media.makeupar.com/c1021194/sdk.js?apiKey=',
  russiaAPIKey: 'bgGSlEg96xisSH0piPFX2w',
  globalAPIUrl: process.env.REACT_APP_YMK_API || 'https://plugins-media.perfectcorp.com/c15857/sdk.js?apiKey=',
  globalAPIKey: 'DvNHeYvLOxYJnJMS2qS5hQ==',
}
export default perfectCorp;
